import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "ptBr",
  messages: {
    ptBr: {
      system: {
        system_name: "Sistema de Gerenciamento de Doação e Transplante da Bahia",
        system_abreviation: "SISTRANS",
      },

      buttons: {
        return_to_grid: 'Voltar para tela inicial',
        continue: 'Continuar',
        save_and_continue: 'Salvar e Continuar',
        save: 'Salvar',
        save_team: 'Salvar Equipe',  
        to_update: 'Atualizar',
        confirm: 'Confirmar',
        clean_up: 'Limpar',
        return: 'Voltar',
        new: 'Novo',
        new_patient: 'Novo Paciente',
        update_patient: 'Atualizar Paciente',
        filter: 'Filtrar',
        cancel: 'Cancelar',
        login: 'Entrar',
        edit: 'Editar',
        search: 'Buscar',
        search_cep: 'Buscar CEP',
        fill_glasgow_scale: 'Sim, preencher escala de Glasgow',
        fill_death_data: 'Preencher dados de morte do paciente',
        generate_excel_sheet: 'Gerar Planilha Excel',
        fill_in_another_moment: 'Preencher em outro momento',
        view_in_graph: 'Visualizar Resultados em Gráfico',
        hide_exames: 'Ocultar Exames',
        view: 'Visualizar',
        no: 'Não',
        yes: 'Sim',
        ok: 'Ok',
        close: 'Fechar',
        download: 'Download',
        delete: 'Excluir',
        new_recruiter: 'Cadastrar Captador',
        conclude_captation: 'Concluir Captação',
        conclude: 'Concluir'
      },

      veracity_term: {
        title: 'Termo de Veracidade',
        description: 'Declaro que as informações prestadas são verdadeiras e assumo a inteira responsabilidade pelas mesmas.'
      },

      titles: {
        patient: 'Paciente',
        potential_donor: 'Potencial Doador',
        patient_data: 'Dados do Paciente:',
        new_exam_title: 'Cadastrar/Acompanhar Exames de Entradas',
        fill_exams: 'Preencher Exames Diários',
        vital_signs: 'Sinais Vitais/ DU/ Drogas',
        blood_gas_data: 'Dados Gasometricos/ Hemoderivados',
        laboratory_test: 'Exames Laboratoriais',
        pcr_data: 'Dados da Parada Cardio Respiratória',
        glasgow_scale: 'Escala de Glasgow',
        pme_pre_requisits: 'Pré-Requisitos para abertura do PME',
        starting_pme: 'Início do Protocolo de ME',
        date_hour_pme: 'Informe a data e hora do primeiro exame',
        clinical_reports: 'Informes Clínicos',
        clinical_histories: 'Antecedentes',
        family_historic: 'Histórico Familiar',
        diseases_and_clinical_conditions: 'Doenças e Condições Clínicas:',
        habits: 'Hábitos, Costumes e Exposições', 
        ending_pme: 'Encerramento de PME',
        family_approve: 'Consentimento da Família',
        family_interview: 'Entrevista Familiar',
        family_allow: 'Aceite Familiar',
        attachments: 'Anexos',
        orgon_in_block: 'Captação em Bloco',
        captation_team: 'Time de Captação:',
        orgons_captureds: 'ORGÃOS CAPTADOS ',
        menu_actions: 'Menu de Ações',
        pending_orgons: 'Orgãos Pendentes',
        edit_profile: 'Editar Perfil',
        new_profile: 'Novo Perfil',
        add_blood_groups: 'Adicionar Grupo Sanguíneo',
        exames_responsibles: 'Responsável pelos Exames:', 
        edit_serology: 'Editar Sorologia',
        cad_serology: 'Cadastrar Sorologia',
        update_blood_group: 'Atualizar Grupo Sanguíneo',
        cad_blood_group: 'Novo Grupo Sanguíneo', 
      },

      sidebar_titles: {
        menu: 'Menu',
        dashboard: 'Dashboard',
        basic_registrations: 'Cadastros Básicos',
        users: 'Usuários',
        profiles: 'Perfis',
        health_unities: 'Unidades de Saúde',
        captation_unities: 'Unidades Captadoras',
        professional_doctos: 'Médicos Profissionais',
        orgons: 'Órgão e Tecido',
        kinship: 'Parentescos',
        attachments_types: 'Tipos de Anexos',
        reasons: 'Motivos e Causas',
        family_denied_reasons: 'Motivos de Recusa Familiar',
        no_interview_reasons: 'Motivos de Não Realização da Entrevista Familiar',
        no_validation_reasons: 'Motivos de Não Validação',
        no_captation_reasons: 'Motivos de Não Captação',
        brain_death_reasons: 'Causas de Morte Neurológicas',
        pcr_death_reasons: 'Causas de Óbito PCR',
        diagnosis_and_comorbidities: 'Diagnósticos e Comorbidades',
        comorbidities: 'Comorbidades',
        initial_diagnosis: 'Diagnósticos Iniciais',
        patients: 'Pacientes',
        follow_up_patients: 'Pacientes em Acompanhamento', 
        serology: 'Sorologia',
        consults_serology: 'Consultar Sorologias',
        consults_nat_serology: 'Consultar Sorologias NAT',
        immunohematology: 'Imunohematologia', 
        consults_blood_groups: 'Consultar Grupos Sanguíneos',
        logs: 'Logs'
      },

      descriptions: {
        me: 'ME - Possível Morte Encefálica',
        pcr: 'PCR - Parada Cardio Respiratória',
        patient_situation: 'Situação do Paciente',
        patient_information: 'Informações do Paciente',
        identified: 'Paciente Identificado?',
        responsibles: 'Responsáveis',
        address: 'Endereço',
        dont_know_cep: 'Não sabe informar o CEP',
        scale_and_description: 'Selecione uma escala e insira a evolução:',
        potential_donor: 'Paciente é um potencial doador?',
        choose_a_reason: 'Selecione um Motivo:',
        choose_a_option: 'Selecione uma opção',
        family_contact_question: 'Houve tentativa de contato com a família?',
        justification: 'Justificativa',
        description: 'Descrição',
        describe: 'Descreva aqui...'
      },

      messages: {
        no_data_found: "Nenhum dado encontrado",   
        fill_glasgow_scale: 'O paciente foi cadastrado e agora pode fazer acompanhamento de escala de Glasgow. Deseja preencher agora?',
        fill_death_data: 'Paciente foi cadastrado(a) com sucesso! Preencha os dados da morte dele(a):',
        required_fields_title: 'Preencher todos os campos obrigatórios',
        required_fields_description: 'Por favor, preencha todos os campos obrigatórios antes de salvar.',
        daily_exams: 'Lembre-se que este acompanhamento deverá ser feito diariamente.',
        registred_exam: 'Exame Registrado!!',
        cant_advance: 'O paciente não pode avançar enquanto não tiver sido identificado.',
        patient_identified: 'Por favor, retorne à tela de cadastro e complete o formulário.',
        required_field: 'Este campo é obrigatório',
        something_went_wrong: 'Algo deu errado!',
        future_date_not_allowed: 'A data não pode ser maior que a data/hora atual',
        describe_reason_not_captured: 'Informe a razão da não captação dos',
        has_no_recruiter: 'Não há captadores cadastrados. Cadastre no botão abaixo',
        add_professionals: 'Adicionar mais profissionais',
        remove_professionals: 'Remover profissional',
        pending_items: 'Ainda precisam ser alterados.',
        item_discarted: 'O que está sendo descartado?',
        items_per_page: 'Registros por página',
        erro_in_serology: 'Erro ao salvar sorologia',
        has_no_patient: 'Não há pacientes para cadastro',

      },

      options:{
        yes: 'Sim',
        not: 'Não',
        dont_know: 'Não sabe informar',
        yes_in_block: 'Sim, em bloco',
        add: 'Adicionar',
      },

      inputs: {
        patient_data: {
          name: 'Nome',
          full_name: 'Nome Completo',
          cpf: 'CPF',
          medical_records: 'Nº do Prontuário Hospitalar',
          rg: 'RG',
          gender: 'Gênero',
          sex: 'Sexo',
          breed: 'Raça',
          probable_age: 'Idade Provável',
          birth_date: 'Data de Nascimento',
          sus_card: 'Cartão do SUS',
          initial_diagnosis: 'Diagnóstico Inicial',
          other_diagnosis: 'Outro Diagnóstico',
          nacionality: 'Nacionalidade',
          mother_name: 'Nome da Mãe',
          telephone: 'Telefone',
          hospital: 'Hospital Notificante',
          cnes: 'CNES',
          sector: 'Setor Informante',
          extension: 'Telefone/Ramal',
          opo: 'OPO REFERÊNCIA',
          opc: 'OPC REFERÊNCIA',
          rgct: 'RGCT',
          responsible_name: 'Nome do Responsável',
          kinship_type: 'Grau de Parentesco',
          cep: 'CEP',
          state: 'Estado',
          city: 'Cidade',
          district: 'Bairro',
          number: 'Nº',
          address: 'Endereço',
          complement: 'Complemento', 
        },
        exams: {
          date_exam: 'Data/Hora do Exame',
          t_graus: 'T(ºC)',
          t_graus_placeholder: 'Temperatura',
          pa: 'PA',
          pa_placeholder: 'Pressão Arterial',
          pam: 'PAM',
          pam_placeholder: 'Pressão Arterial Média',
          fc: 'FC',
          fc_placeholder: 'Frequência Cardíaca',
          diuresis: 'Diurese 24H',
          sato2_pulmao: 'SAT.O²',
          fio: 'FIO²',
          po: 'PO²',
          pco: 'PCO²',
          ph: 'pH',
          hb: 'HB',
          ht: 'HT',
          silly: 'Leuco',
          plts: 'PLTS',
          plts_placeholder: 'Plaquetas',
          tp: 'TP',
          rni: 'RNI',
          canes: 'Bastões',
          segmented: 'Segmentados',
          glucose: 'Glicemia',
          amylase: 'Amilase',
          tgo: 'TGO',
          tgp: 'TGP',
          gamagt: 'Gama GT',
          fosf: 'Fosfatase Alcalina',
          bil_total: 'Bilirrubina Total',
          bil_direta: 'Bilirrubina Direta',
          creat: 'Creatinina',
          urea: 'Uréia',
          na: 'Sodio (NA)',
          k: 'Potássio (K)',
        },
        pcr_donor_data: {
          clinical_historic: 'História Clínica...',
          pcr_date: 'PCR',
          pcr_hour: 'Hora',
          cold_body: 'Corpo Resfriado',
          ending_pme_date: 'Data do Encerramento do PME (último exame)',
          ending_pme_hour: 'Hora',
          cause_of_death: 'Causa do Óbito',
        },
        glasgow_scale: {
          description: 'Escala',
          condition_id: 'Condição...',
          condition_other: 'Outros',
          condition_other_placeholder: 'Descreva aqui...',
        },
        starting_pme: {
          pme_start_datetime: 'Data e Hora',
        }, 
        clinical_reports: {
          admission_date: 'Data de Admissão',
          height: 'Altura(m)',
          weight: 'Peso(kg)',
          brain_death_cause: 'Causa da Morte Neurológica',
          another_brain_death_cause: 'Qual a causa da morte neurológica?',
          comorbidities: 'Comorbidades',
          another_comorbiditie: 'Qual outra comorbidade?',
          use_vaccine_last_30_days: 'O doador fez uso de vacina com vírus vivo atenuado nos últimos 30 dias?',
          test_covid: 'Teste para SARS-COV-2?',
          result_covid_test: 'Resultado:',
          tuberculosis_case: 'Caso suspeito ou confirmado de Tuberculose em atividades?',
          malignant_neoplasms: 'Neoplasia malignas ativas?',
          blood_products: 'Recebeu sangue e Hemoderivados?',
          positive_blood_culture: 'Hemocultura Positiva?',
          other_positive_culture: 'Outras culturas positivas?',
          infection: 'Infecção?',
          antibiotic_use: 'Faz uso de antibióticos?',
          material_for_serology: 'Coleta de material para sorologia?',
          vasoactive_drugs: 'Drogas vasoativas?',
          pcr_reports: 'Relato de PCR?',
        },
        clinical_histories:{
          donor_diabetes: 'Diabetes no doador?',
          family_history_diabetes: 'Histórico de diabete familiar?',
          diabetes_relatives: 'Qual tipo de parente?',
          bronchoaspiration: 'Broncoaspiração no Internamento?',
          inpatient_dialysis: 'Diálise no Internamento?',
          dst: 'DST?',
          has: 'HAS?',
          asthma: 'Asma?',
          dpoc: 'DPOC?',
          facial_trauma: 'Trauma na face?',
          previous_surgery: 'Cirúrgia Prévia?',
          heart_disease: 'Cardiopatia?',
          infectious_disease: 'Doença Infectocontagiosa?',
          corneal_surgery: 'Relato de cirurgia na córnea?',
          piercing: 'Piercings?',
          smoker: 'Tabagista?',
          tattoo: 'Tatuagens?',
          illicit_drugs: 'Usuários de drogas ilícitas?',
          injectable_drugs: 'Injetáveis?',
          alcoholic: 'Alcoolista?',
        }, 
        pcr_clinical_histories:{
          use_alcool: 'Uso abusivo de álcool?',
          use_drugs: 'Uso de drogas ilícitas injetáveis?',
          facial_trauma: 'Trauma em face?',
          corneal_surgery: 'Relato de cirurgia na córnea?',
          use_vaccine: 'Faz uso de vacina com vírus vivo atenuado nos últimos 30 dias?',
          wich_vaccine: 'Qual vacina?',
          use_antibiotic: 'Faz uso de antibiótico sem vinculação a Infecção?',
          type_antibiotic: 'Tipo de Antibiótico:',
          dose: 'Dose:',
          date: 'Data:',

        },
        ending_pme:{
          pme_finished: 'PME finalizado?',
          pme_start_datetime: 'Data e Hora do primeiro Exame',
          last_exam_datetime: 'Data e Hora do último Exame',
          justification: 'Justificativa',
          justification_placeholder: 'Descreva a razão',
          tissue_harvesting_only_flg_question: 'Prosseguir para captação de tecidos?',
        },
        family_authorization:{
          family_allow_question: 'Houve Aceite Familiar?',
          describe_reason: 'Descreva o Motivo:',
          interview_responsible: 'Nome responsável pela Entrevista:',
          interview_datetime: 'Data e hora da Entrevista Familiar:',
        },
        family_interview: {
          family_interview_question: 'Entrevista familiar realizada?'
        },
        attachments: {
          kind_of_attachment: 'Tipo do Documento',
          description: 'Descrição do Anexo',
          attachment: 'Documento em PDF/JPG/JPEG/PNG',
          input_attachment: 'Inserir documento', 
        },
        captations: {
          type_cirurgy: 'Validação do tipo de captação:',
          start_surgery_date_and_hour: 'Data/Hora Início da cirurgia',
          aortic_clamping: 'Data/Hora Clampeamento de Aorta',
          perfusion_time: 'Tempo de perfusão',
          end_surgery: 'Data/Hora Término da cirurgia',
          reason_not_captured: 'Selecione o motivo da não captação',
          reason_not_captured_description: 'Motivo da Desistência',
          captured: 'Captado?',
          captation_hour: 'Data/Hora da Captação',
          biopsy: 'Necessita Biópsia?',
          packed: 'Devidamente acondicionado?',
          preservation_solutions: 'Solução de Preservação',
          number_lot: 'Nº do Lote',
          lot_expiration_date: 'Data de Validade do Lote',
          nephrectomy: 'NEFRECTOMIA',
          normal_morphology: 'Morfologia Normal?',
          single_arterial_pedicle: 'Pedículo Arterial',
          unic: 'Único?',
          single_venous_pedicle: 'Pedículo Venoso',
          single_ureteral_rout: 'Via Ureteral',
          adequate_perfusion: 'Perfusão Adequada?',
          surgical_description: 'Descrição Cirúrgica:',
          intercorrency: 'Houve intercorrência durante o procedimento?',
          intercorrency_description: 'Descreva a intercorrência:',
          reason_not_captured_orgon: 'Selecione o motivo da não captação do orgão',
          reason_for_withdrawal: 'Motivo da desistência:'
        },
        captation_team: {
          type_captation_team: 'Tipo de Equipe Captadora:',
          only_tissues: 'Captadora de Tecidos',
          only_orgons: 'Captadora de Orgãos',
          donor_unity: 'Unidade Doadora',
          captation_unity: 'Unidade Captadora',
          select_orgons: 'Selecione os Orgãos Captados pelo Time',
          recruiter: 'Captador',
          register_number: 'Nº do registro',
          profession: 'Profissão',
          professional_name: 'Nome do Profissional',
        },
        orgons_captureds: {
          orgon_status: 'Status do órgão',
          discard: 'DESCARTE',
          transplant: 'TRANSPLANTE',
          disponibilization: 'DISPONIBILIZAÇÃO',
          rgct: 'RGCT',
          state: 'Estado',
          transplanter_center: 'Centro Transplantador',
          globe: 'Globo',
          cornea: 'Córnea',
          reason: 'Motivo de',
          describe: 'Descreva:',
        },
        reasons_not_validation: {
          description: 'Descreva o motivo',
          kind_of_donor: 'Tipo de Paciente',
        },
        reasons_not_captation: {
          type_use: 'Tipo de Uso',
          type_captation: 'Tipo de Captação',
          type_orgon: 'Tipo de Orgão/Tecido',
        },
        profiles: {
          name: 'Nome do Perfil',
          slug: 'Slug do Perfil',
        },
        orgons_tissues: {
          description: 'Descreva o orgão/tecido',
          other_hospitals: 'Outros hospitais',
        },
        file_types: {
          search: 'Pesquisar tipos de anexo',
        },
        doctors: {
          name: 'Nome Profissional',
        },
        death_cause: {
          name: 'Causa de morte neurológica',
        },
        captation_unities: {
          description: 'Descreva unidade captadora',
          type_reference: 'Tipo de Unidade',
        },
        serology: {
          serology: 'Sorologia',
          potential_donor: 'Paciente/Potencial Doador',
          report_number: 'Nº do Laudo/AAAA',
          sample_date: 'Data da Coleta de Amostra',
          responsible_name: 'Nome do Responsável',
          advice: 'Conselho',
          release_date: 'Data e Horário da Liberação',
          cornea: 'Córnea',
          esclera: 'Esclera',
          multiple_orgons: 'Múltiplos Orgãos',
          observations: 'Observações',
          nat_serologies: 'Sorologia NAT',
        },
        blood_group:{
          blood_group: 'Grupo Sanguíneo',
          type_report: 'Tipo de Exame',
          blood_factor: 'Fator Sanguíneo', 
          rh_factor: 'Fator RH',
        },
        filter: {
          title: 'FILTRO',
          subtitle: 'Selecione os Filtros',

        }
      },
    }
  }
});

export default i18n;
